export default (arrayObjects, prop, value) => arrayObjects.splice(
    arrayObjects.findIndex(obj => obj[prop] === value)
, 1);